// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__cardMarginBot___drzTQ {
  margin-top: 1rem;
}

.styles__sectionTitle___ZtkRi {
}

.styles__sectionNoMargin___K7td3 {
  display: flex;
}

.styles__feeSchedule___XnCm1 {
  width: calc(99.9% * 12/12 - (30px - 30px * 12/12));
}

.styles__feeSchedule___XnCm1:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__feeSchedule___XnCm1:last-child {
  margin-right: 0;
}

.styles__feeSchedule___XnCm1:nth-child(12n) {
  margin-right: 0;
  float: right;
}

.styles__feeSchedule___XnCm1:nth-child(12n + 1) {
  clear: both;
}

.styles__depositCols___rI_C6 {
  padding: 0 1rem;
  margin-right: 0 !important;
}

.styles__depositCols___rI_C6 .styles__depositLabel___N5Fvs {
    font-weight: bold;
    margin-bottom: 0.4rem !important;
  }

.styles__depositCols___rI_C6 .styles__depositValue___GIpc6 {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 90px;
    margin-left: 2rem;
  }

.styles__depositCols___rI_C6 .styles__depositValue___GIpc6 .styles__rate___jFs_r {
      flex: 0 0 auto;
    }

.styles__depositCols___rI_C6 .styles__depositValue___GIpc6 .styles__descriptionFull___PM7yF {
      flex: 1;
    }
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Distributions/components/FeeSchedule/styles.css"],"names":[],"mappings":"AAIA;EAEE,gBAAgB;AAClB;;AAEA;AAEA;;AAEA;EAEE,aAAa;AACf;;AAEA;EACE,kDAAkB;AACpB;;AAFA;EACE,WAAkB;EAAlB,kBAAkB;EAAlB,WAAkB;AACpB;;AAFA;EACE,eAAkB;AACpB;;AAFA;EACE,eAAkB;EAAlB,YAAkB;AACpB;;AAFA;EACE,WAAkB;AACpB;;AAEA;EAEE,eAAe;EACf,0BAA0B;AAsB5B;;AApBE;IACE,iBAAiB;IACjB,gCAAgC;EAClC;;AAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;EASnB;;AAPE;MACE,cAAc;IAChB;;AAEA;MACE,OAAO;IACT","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtGrayDark, textDark, gtGray, gtGrayMid from colors;\n\n.cardMarginBot {\n  composes: cardMarginBot from helpers;\n  margin-top: 1rem;\n}\n\n.sectionTitle {\n  composes: sectionTitle from helpers;\n}\n\n.sectionNoMargin {\n  composes: sectionNoMargin from helpers;\n  display: flex;\n}\n\n.feeSchedule {\n  lost-column: 12/12;\n}\n\n.depositCols {\n  composes: serif from helpers;\n  padding: 0 1rem;\n  margin-right: 0 !important;\n\n  .depositLabel {\n    font-weight: bold;\n    margin-bottom: 0.4rem !important;\n  }\n\n  .depositValue {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 90px;\n    margin-left: 2rem;\n\n    .rate {\n      flex: 0 0 auto;\n    }\n\n    .descriptionFull {\n      flex: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtGrayDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]}`,
	"textDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtGrayMid": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayMid"]}`,
	"cardMarginBot": `styles__cardMarginBot___drzTQ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["cardMarginBot"]}`,
	"sectionTitle": `styles__sectionTitle___ZtkRi ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"sectionNoMargin": `styles__sectionNoMargin___K7td3 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"feeSchedule": `styles__feeSchedule___XnCm1`,
	"depositCols": `styles__depositCols___rI_C6 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["serif"]}`,
	"depositLabel": `styles__depositLabel___N5Fvs`,
	"depositValue": `styles__depositValue___GIpc6`,
	"rate": `styles__rate___jFs_r`,
	"descriptionFull": `styles__descriptionFull___PM7yF`
};
export default ___CSS_LOADER_EXPORT___;
